import { PH_ICON_MAP, PHOSPHOR_TO_LUCIDE, LUCIDE_ICON_MAP } from "../constants/icons";
import { TwemojiImg } from "./TwemojiImg";

export function CategoryIcon({ cat, size = 16, color, style = {} }) {
  const col = color || cat?.color || "#d4789a";
  // New: phosphorIcon (Phosphor duotone)
  if (cat?.phosphorIcon && PH_ICON_MAP[cat.phosphorIcon]) {
    const Icon = PH_ICON_MAP[cat.phosphorIcon];
    return <Icon size={size} weight="duotone" color={col} style={{ flexShrink: 0, ...style }} />;
  }
  // Legacy: lucideIcon or phosphorIcon mapped to Lucide
  const iconName = cat?.lucideIcon || PHOSPHOR_TO_LUCIDE[cat?.phosphorIcon];
  if (iconName && LUCIDE_ICON_MAP[iconName]) {
    const Icon = LUCIDE_ICON_MAP[iconName];
    return <Icon size={size} color={col} style={{ flexShrink: 0, ...style }} />;
  }
  // Fallback — render emoji
  return <TwemojiImg emoji={cat?.emoji || "⭐"} size={size} style={style} />;
}
